import { routes as registerRoutes } from "./register-cover/routes";

export const routes = [
    ...registerRoutes(`insurance`)
]
